import { createTheme } from "@mui/material";
import { deepPurple, grey, indigo, pink, red, teal } from "@mui/material/colors";

const darkTheme = createTheme({
    palette: {
        mode: "dark",
        secondary: {
            main: deepPurple["A200"]
        },
        success: {
            main: teal["A200"]
        },
        background: {
            paper: grey["900"],
            default: "#121212"
        },
    }
});

export default darkTheme;